export default {
  'importFile.allowPartialImport': 'Allow Partial Import',
  'importFile.fileLayout': 'File Layout',
  'importFile.stripQuotes': 'Strip Quotes',
  'importFile.zeroAmountField': 'Zero Amount Field',
  'importFile.deleteUnmatchedRecords': 'Delete Unmatched Records',
  'importFile.importNachaFile': 'Import NACHA File',
  'importFile.createNewPayments': 'Create New Payments',
  'importFile.createNewTemplates': 'Create New Templates',
  'importFile.info':
    'Any dollar value specified in your import file that does not include a decimal \nwill be imported with an implied decimal-- two positions from the rightmost digit. \nFor example, a value of 1234 will be imported as $12.34.'
};
